// import React from 'react';

import { Link } from "react-router-dom";
import "../assets/css/style.css";
import "../assets/css/style.css.map";
import "../assets/css/slick.min.css";

// import POTATOFLAKES from "../assests/img/ProductsImages/POTATOFLAKES.jpg";
import potfl from "../assets/img/potfl1.png";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import potatoban1 from "../assets/img/potatoban1.png";
import header_potato from "../assets/img/header_potato.png";
import Footer from "./footer";
import PotatoFlakes from "../components/PotatoFlakes";

const Potatoflakes = () => {
  return (
    <div>
      <div classNameName="d-none d-md-block">
        <div
          id="slider"
          classNameName="ls-wp-container fitvidsignore hero-6 th-hero-carousel"
          style={{ margin: "0 auto" }}
        >
          <div
            classNameName="ls-slide"
            data-ls="duration:5000; kenburnsscale:1.2;"
          >
            <div className="infrastructure-name">
              <div style={{ marginTop: "-40px" }}>
                <ul style={{ listStyleType: "none", padding: 20 }}>
                  <li>
                    <h1
                      style={{ color: "white", margin: 0, fontFamily: "helvetica", padding: 0 }}
                       
                    >
                      {/* POTATO FLAKES & MASHED */}
                      POTATO FLAKES & MASH
                    </h1>
                  </li>
                  <li>
                    <Link to="/home" style={{ color: "white", padding: 4 }}>
                      <span
                        className="homeclass"
                        style={{ fontFamily: "helvetica" }}
                      >
                        Home
                      </span>{" "}
                      &nbsp;
                    </Link>
                    <span style={{ color: "white" }}>
                      &gt; &nbsp;
                      <span
                        className="redname"
                        style={{ fontFamily: "helvetica", color: "#F0B323" ,color: '#0f1138'}}
                      >
                        {/* Potato Flakes & Mashed */}
                        Potato Flakes & Mash
                      </span>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <img
              width="2000"
              height=""
              src={header_potato}
              className="ls-l ls-img-layer factory"
              alt="pic"
              decoding="async"
             
              data-ls="offsetxin:500; durationin:600; delayin:100; easingin:easeOutBack; rotatein:80; bgcolorin:transparent; colorin:transparent;"
            />
          </div>
        </div>
      </div>

<PotatoFlakes />
      <div className="d-md-block hidearrow mb-5 pb-5" >

          <div className='container' >
              <img
                  // width="2000"
                  width="100%"
                  height="700"
                  src={potfl}
                  className="ls-l ls-img-layer"
                  alt="image"
                  decoding="async"
                  style={{
                      fontSize: '36px',
                      color: '#000',
                      stroke: '#000',
                      strokeWidth: '0px',
                      textAlign: 'left',
                      fontStyle: 'normal',
                      textDecoration: 'none',
                      textTransform: 'none',
                      fontWeight: '400',
                      letterSpacing: '0px',
                      backgroundPosition: '0% 0%',
                      backgroundRepeat: 'no-repeat',
                      backgroundClip: 'border-box',
                      overflow: 'visible',
                      left: '0px',
                      top: '107px',
                      WebkitBackgroundClip: 'border-box'
                  }}
                  data-ls="offsetxin:500; durationin:600; delayin:100; easingin:easeOutBack; rotatein:80; bgcolorin:transparent; colorin:transparent;"
              />
          </div>
      </div>
      <br/>
      <Footer />
    </div>
  );
};

export default Potatoflakes;
